import requestv2 from "~/utils/http-v2";

const ticketApi = {
    get : async (params) => {
        const url = 'v2/ticket';
        return await requestv2.get(url, {params});
    },
    detail : async (params) => {
        const url = `v2/ticket/detail/${params.id}`;
        return await requestv2.get(url, {params});
    },
    isRead : async (id) => {
        const url = `v2/ticket/is-read/${id}`;
        return await requestv2.post(url);
    },
    comment : async (params) => {
        const url = `v2/ticket/comment/${params.id}`;
        return await requestv2.get(url, {params});
    },
    addComment : async (params) => {
        const url = 'v2/ticket/comment';
        return await requestv2.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    status : async (params) => {
        const url = `v2/ticket/status/${params.id}`;
        return await requestv2.post(url, params);
    },
    statusTab : async (params) => {
        const url = `v2/ticket/status-tab`;
        return await requestv2.get(url, params);
    },
};

export default ticketApi;